<template>
  <div>
    <div ref="telegramL"></div>
    <div v-html="hi"></div>
  </div>
</template>

<script>
import {ref,onMounted} from 'vue'
export default {
  name: "TeleBot",
  setup(){

    const hi=ref("")
    const telegramL=ref(null)
    const teleScript=document.createElement('script')
    const onTelegramAuth=(user)=>{
      console.log(user)
      let sha256 = require ( "js-sha256"). sha256
      let secret_key = sha256(BOT_TOKEN)
      console.log(secret_key)
      hi.value="<h1>Hello, <a href=\"https://t.me/"+user.username+"\">"+user.first_name+" "+user.last_name+"</a>!</h1>"
    }
    teleScript.async = true
    teleScript.src = 'https://telegram.org/js/telegram-widget.js?15'
    teleScript.setAttribute('data-size', "large")
    teleScript.setAttribute('data-userpic', "false")
    teleScript.setAttribute('data-telegram-login',"aeTrade_bot")
    teleScript.setAttribute('data-request-access', "write")
    teleScript.setAttribute('data-radius', "5")
    window.onTelegramAuth = onTelegramAuth
    teleScript.setAttribute('data-onauth', "window.onTelegramAuth(user)")
    const BOT_TOKEN="2077538829:AAF1mTE2PtyaqVvOOfFYTD8lFNhAIg49fiA"

    onMounted(()=>{
      telegramL.value.appendChild(teleScript)
    })
    return{
      telegramL,
      hi

    }
  }
}
</script>

<style scoped>

</style>